(($) => {
	// ========================================================
	// GLOBALS
	// ========================================================

	const Globals = {
		// Variables
		$body: $("body"),
		$window: $(window),
		$document: $(document),
		// Methods
		addMobileDetection: function () {
			// @link https://dev.to/timhuang/a-simple-way-to-detect-if-browser-is-on-a-mobile-device-with-javascript-44j3
			if (
				/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
					navigator.userAgent
				)
			) {
				this.$body.addClass("is-mobile");
			}
		},
		add: function (key, val) {
			this[key] = val;
		},
	};

	Globals.addMobileDetection();

	Globals.add("sliders", {
		nextArrow: `<button class="slick-next slick-arrow" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" fill="none"><g><rect width="30" height="30" x="-1" y="1" stroke="#E6DED7" stroke-width="2" rx="15" fill="#E6DED7" transform="matrix(-1 0 0 1 30 .059)"/><path fill="#683B14" d="m21.532 16.026-1.543-1.414-7.713 7.07 1.542 1.415z"/><path fill="#683B14" d="m19.99 17.44 1.542-1.414-7.713-7.07-1.543 1.414z"/></g></svg></button>`,
		prevArrow: `<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" fill="none"><g><rect width="30" height="30" x="1" y="1.059" stroke="#E6DED7" stroke-width="2" rx="15" fill="#E6DED7"/><path fill="#683B14" d="m10.468 16.026 1.543-1.414 7.713 7.07-1.542 1.415z"/><path fill="#683B14" d="m12.01 17.44-1.542-1.414 7.713-7.07 1.543 1.414z"/></g></svg></button>`,
	});

	/**
	 * Gulp include scripts
	 *
	 * @link https://www.npmjs.com/package/gulp-include
	 */
	/**
	 * Gravity forms floating labels.
	 */
	$(document).on('gform_post_render', function(event, form_id, current_page){
		const activeClass = 'is-active';
		const wrapperSelector = '.gfield, .gform-grid-col';
		const $selectors = $('.js-gform input[type=text], .js-gform input[type=tel], .js-gform input[type=email], .js-gform input[type=number], .js-gform textarea');
	
		// Inline label forms: Add active class if input has value
		$selectors.each(function () {
			if ($(this).val().length) {
				$(this).closest(wrapperSelector).addClass(activeClass);
			}
		});
	
		$('.js-gform select').on('change', function() {
			if ($(this).val() === "") {
				$(this).closest('.gfield').removeClass(activeClass);
			} else {
				$(this).closest(wrapperSelector).addClass(activeClass);
			}
		});
	
		// Inline label forms: Add active class on focus
		$selectors.on('focus', function () {
			$(this).closest(wrapperSelector).addClass(activeClass);
		});
	
		// Inline label forms: Remove active class on blur
		$selectors.on('blur', function () {
			if (!$(this).val().length || $(this).val().includes('_')) {
				$(this).closest(wrapperSelector).removeClass(activeClass);
			}
		});
	});
	
	$('.card-slider').each((i, el) => {
		const $slider = $(el);
		const $track = $slider.children('.acf-innerblocks-container');
		const { prevArrow, nextArrow } = Globals.sliders;
		const $controls = $slider.next('.js-slider-controls');
	  
		const options = {
		  mobileFirst: true,
		  dots: true,
		  prevArrow,
		  nextArrow,
		  appendArrows: $controls,
		  appendDots: $controls,
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  infinite: true,
		  rows: 0,
		  centerMode: true,
		  centerPadding: '12px',
	  	  responsive: [
			{
			  breakpoint: 781,
			  settings: {
				centerMode: false,
				centerPadding: '0px'
			  }
			}
		  ]
		};
	  
		$track.on('init reInit setPosition', function (evt, slick) {
		  if (!slick) return;
		  const count = slick.slideCount;
		  const sts = slick.options.slidesToShow || 1;
		  const canSlide = count > sts;
		  if ($controls && $controls.length) {
			$controls.toggle(!!canSlide);
		  }
		});
	  
		$track.addClass('slick-equal-heights');
		$track.slick(options);
	  
		if ($track.find('.slick-track').length === 0) {
		  $track.find('> *').removeAttr('aria-describedby role tabindex aria-hidden');
		  $track.find('a[tabindex="-1"], button[tabindex="-1"]').removeAttr('tabindex');
		}
	  });
	  
		(function ($) {
	    var resizeTimer;
	  
	    function isMobile() {
	      // below 991px to match bp($bp-lg)
	      return window.matchMedia('(max-width: 990.98px)').matches;
	    }
	  
	    function initIconAccordion() {
	      var $wrap = $('.icon-accordion');
	      if (!$wrap.length) return;
	  
	      // target the actual child blocks
	      var $items = $wrap.find('> .block-card-icon');
	  
	      if (isMobile()) {
	        $items.removeClass('is-open').first().addClass('is-open');
	  
	        $items.each(function () {
	          var $item = $(this);
	          var $title  = $item.find('.title');
	          var $toggle = $item.find('.toggle-icon');
	  
	          $title.off('click.iconAcc').on('click.iconAcc', function () {
	            toggleItem($wrap, $item);
	          });
	  
	          $toggle.off('click.iconAcc').on('click.iconAcc', function (e) {
	            e.preventDefault();
	            e.stopPropagation();
	            toggleItem($wrap, $item);
	          });
	        });
	      } else {
	        $items.removeClass('is-open');
	        $items.find('.title, .toggle-icon').off('click.iconAcc');
	      }
	    }
	  
	    function toggleItem($wrap, $item) {
	      var alreadyOpen = $item.hasClass('is-open');
	      $wrap.find('> .block-card-icon.is-open').removeClass('is-open');
	      if (!alreadyOpen) $item.addClass('is-open');
	    }
	  
	    $(document).ready(initIconAccordion);
	  
	    $(window).on('resize', function () {
	      clearTimeout(resizeTimer);
	      resizeTimer = setTimeout(initIconAccordion, 150);
	    });
	  })(jQuery);
	  

	// ========================================================
	// GENERIC SLICK SLIDER
	// - Control options with data-slick
	// ========================================================

	const $sliders = $(".js-slider");

	// Check for sliders and loop through each
	if ($sliders.length) {
		$sliders.each((i, el) => {
			const $slider = $(el);
			const $controls = $slider.next(".js-slider-controls");
			const $filler = $slider.find(".is-col-filler");
			const { nextArrow, prevArrow } = Globals.sliders;

			// Initialize Slick
			$slider.slick({
				nextArrow,
				prevArrow,
			});

			// If there is a controls slot, add arrows and dots there.
			if ($controls.length) {
				$slider.slick("setOption", "appendDots", $controls, true);
				$slider.slick("setOption", "appendArrows", $controls, true);
			}

			// Remove any filler cards
			if ($filler.length) {
				const lastSlide = $slider.find("[data-slick-index]").length - 1;
				$slider.slick("slickRemove", lastSlide);
			}

			// Remove accessibility attributes if slick has not been initialized (I.e. desktop "unslick")
			if ($slider.find(".slick-track").length === 0) {
				$slider
					.find("> *")
					.removeAttr("aria-describedby role tabindex aria-hidden");
				$slider
					.find('a[tabindex="-1"], button[tabindex="-1"]')
					.removeAttr("tabindex");
			}
		});
	}

	// Gravity Forms - Clicking on step numbers trigger form change
	$(document).on("click", ".gf_step", (e) => {
		const $this = $(e.currentTarget);
		const $form = $this.parents("form");
		const formID = $form.data("formid");
		const targetPageNum = parseInt($this.find(".gf_step_number").text());
		const $input = $(`#gform_target_page_number_${formID}`);

		$input.val(targetPageNum);
		$form.trigger("submit");
	});

	// ========================================================
	// Fullscreen Popup (open via href="#quote-form")
	// ========================================================
	const $overlay = $("#fullscreen-popup");
	const $sections = $overlay.find(".popup-section");

	function openPopup(e) {
		if (e) e.preventDefault();
		const $t = $(e.currentTarget).closest("a,button");
		const href = ($t.attr("href") || "").trim(); // "#quote-form"

		// show only the targeted section
		$sections.removeClass("active").attr("aria-hidden", "true");
		if (href && href.startsWith("#")) {
			$overlay.find(href).addClass("active").attr("aria-hidden", "false");
		} else {
			// fallback to quote
			$overlay
				.find("#quote-form")
				.addClass("active")
				.attr("aria-hidden", "false");
		}

		$overlay.addClass("visible").attr("aria-hidden", "false");
		$("body").addClass("scroll-locked");
	}

	function closePopup(e) {
		if (e) e.preventDefault();
		$overlay.removeClass("visible").attr("aria-hidden", "true");
		$("body").removeClass("scroll-locked");
		// reset sections
		$sections.removeClass("active").attr("aria-hidden", "true");
	}

	// Open on either href
	$(document).on(
		"click",
		'a[href="#quote-form"], button[href="#quote-form"]',
		openPopup
	);

	// Close on close button
	$(document).on("click", ".popup-close", closePopup);
})(jQuery);
